<template>
  <div class="about">
    <img :src="'http://'+UrlList" alt="" v-if="UrlList">
    <div class="about-content" >
      <div class="content-title">
        <router-link v-for="(item,index) in titles" :key="index" :to="TitleUrl[index]">
          <a  :class="{current : current == index}" @click="click(index)">{{item}}</a>
        </router-link>
      </div>
      <router-view></router-view>
    </div>
  </div>
</template>
<script>

import Company from "@/views/About/Company";
import CompanyInfo from "@/views/About/CompanyInfo";
import CompanyCulture from "./CompanyCulture";
import CompanyMean from "./CompanyMean";
import CompanyHope from "./CompanyHope";

export default {
  components: {CompanyHope, CompanyMean, CompanyCulture, CompanyInfo, Company,},
  data(){
    return{
      titles:['公司简介','企业愿景','经营理念','发展历程','企业文化'],
      current:0,
      UrlList:{},
      TitleUrl:['/about/intro','/about/hope','/about/mean','/about/develop','/about/culture']
    }
  },
  created() {
      this.GetUrlData()
  },
  methods:{
    click(index){
      this.current = index
    },
    GetUrlData(){
      this.$axios.get('/api/photo/getBuildBanana',{params:{
          id:32
        }}).then(res=>{
        this.UrlList=res.data.data[0].photoList[0].address;
      })
    }
  }
}
</script >
<style lang="less" scoped>
  .about{
    img{
      width: 100%;
      height: 250px;
      object-fit: cover;
    }
    .about-content{
      min-height: 72vh;
      background: url('../../assets/Culture.png') center center / cover no-repeat ;
      .content-title{
        text-align: center;
        margin-top: 10px;
        margin-bottom: 40px;
        .current{
          color: #358ED7;
        }
        a{
          text-decoration: none;
          color: black;
          margin: 30px;
          width: 72px;
          height: 18px;
          font-size: 18px;
          font-family: SourceHanSansCN-Bold, SourceHanSansCN;
          font-weight: bold;
          line-height: 27px;
        }
      }
    }

  }
</style>